import { createClient } from '@/shared/api';
import RE_CAPTURE_AUTO_EVENTS from '@/entities/event/api/mutations/recaptureAutoEvents';
import type {
  RecaptureAutoEventsMutation,
  RecaptureAutoEventsMutationVariables,
} from '@/shared/api/generated/graphql';

export type RecaptureAutoEventsResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the RecaptureAutoEventsInput GraphQL input once its server-side shape is documented
/**
 * Asks the server to re-capture strips for automatically detected events. Runs the recaptureAutoEvents mutation and returns its field, tolerating a nullish response.
 *
 * @param input - Mutation input naming the events to re-capture.
 * @returns A promise resolving to the recaptureAutoEvents result.
 */
const handleRecaptureAutoEvents = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    RecaptureAutoEventsMutation,
    RecaptureAutoEventsMutationVariables
  >({
    mutation: RE_CAPTURE_AUTO_EVENTS,
    variables: {
      input,
    },
  });
  const { data } = result || {};
  const { recaptureAutoEvents } = data || {};
  return recaptureAutoEvents;
};

export default handleRecaptureAutoEvents;
